/*
 * DAILY共通クラス
 * デイリースポーツオンラインの各画面で共通で使用する処理を定義
 */
var DAILY = DAILY || (function () {
  'use strict';

  /*
   * オブジェクトの拡張：forInの定義
   */
  Object.defineProperty(Object.prototype, "forIn", {
    value: function (fn, self) {
      self = self || this;
      Object.keys(this).forEach(function (key, index) {
        var value = this[key];
        fn.call(self, key, value, index);
      }, this);
    }
  });

  /*
   * 広告を監視するためのクラス
   */
  var MoniterFixedAdd = (function () {
    var cons = {};

    function MoniterFixedAdd() {
      this.initialize();
    }

    MoniterFixedAdd.prototype.initialize = function () {
      cons = {};
    };

    MoniterFixedAdd.prototype.setConditions = function () {

      cons.$main = $('.pageMain-inner .primaryContents');
      cons.$side = $('.pageMain-inner .secondaryContents');
      cons.$footer = $('.pageFooter');
      cons.isMonitaring = false;

      cons.$side.removeClass('is-fixed').css({
        'right': 'inherit',
        'bottom': 'inherit'
      });

      if (cons.$side.height() < cons.$main.height()) {

        var $targetFixedAdd = cons.$side.find('.fixedAdd');

        if (0 < $targetFixedAdd.length) {

          cons.addT = $targetFixedAdd.offset().top,
            cons.addH = $targetFixedAdd.height();

          cons.fixedB = 0;
          $targetFixedAdd.nextAll().each(function () {
            cons.fixedB += $(this).outerHeight(true);
          });
          /* 2016-08-04 五輪ハイライトかぶり対応 */
          cons.fixedB = cons.fixedB + 20;
          cons.isMonitaring = true;
        }
      }

      cons.bh = $('body').height();
      cons.bw = $('.wrapper').width();
      cons.fh = $('.pageFooter').height();
      cons.sh = $('.specialContents').height();

      /*
      cons.$side.removeClass('is-fixed').css({
        'right': 'inherit',
        'bottom': 'inherit'
      });
      */
    };

    MoniterFixedAdd.prototype.monitering = function () {
      if (!cons.isMonitaring) {
        return;
      }
      var $win = $(window);
      var t = $win.scrollTop(),
        l = $win.scrollLeft(),
        wh = window.innerHeight,
        ww = window.innerWidth;


      if (cons.addT + cons.addH + 10 < t + wh && t + wh < cons.bh - (cons.fh + cons.sh) - cons.fixedB) {
        cons.$side.addClass('is-fixed').css({
          // 'right': 'calc((100% - 1000px) / 2)',
          'bottom': '-' + cons.fixedB + 'px'
        });
      } else if (cons.bh - (cons.fh + cons.sh) - cons.fixedB <= t + wh) {
        var newFixedB = cons.fixedB - (t + wh - (cons.bh - (cons.fh + cons.sh) - cons.fixedB) + 60);
        /* 2016-08-04 五輪ハイライトかぶり対応 */
        //        var newFixedB = cons.fixedB - (t + wh - (cons.bh - (cons.fh + cons.sh) - cons.fixedB));
        if (10 < newFixedB) {
          cons.$side.css({
            'bottom': '-' + newFixedB + 'px'
          });
        } else {
          newFixedB = -1 * newFixedB + 10;
          cons.$side.css({
            'bottom': newFixedB + 'px'
          });
        }
      } else {
        cons.$side.removeClass('is-fixed').css({
          //          'right': 'inherit',
          'bottom': 'inherit'
        });
      }

      if (ww < cons.bw && cons.$side.hasClass('is-fixed')) {
        cons.$side.css({
          'left': (-1 * l) + 'px'
        });
      } else {
        cons.$side.css({
          'left': 'inherit'
        });
      }
    };

    MoniterFixedAdd.prototype.startMoniter = function () {
      var _self = this;

      $(window).on('scroll', function () {
        _self.monitering();
      });
    };

    return MoniterFixedAdd;
  })();

  /*
   * 写真部分をスライド表示するためのクラス
   */
  var FigureCarousel = (function () {

    function FigureCarousel(arg) {
      this.initialize(arg);
    }

    FigureCarousel.prototype.initialize = function (arg) {
      this.data = arg.data;
      this.$self = $(arg.id);
      this.$inner = this.$self.find('.figureCarousel-inner')
      this.$item = this.$self.find('.figureCarousel-item')
      this.$prev = $('<a href="#" class="prev hide"></a>'),
        this.$next = $('<a href="#" class="next hide"></a>');

      var w = this.$item.eq(0).width(),
        s = this.$item.length;

      this.$inner.css({ 'width': (w * s) + 'px' });

      this.$dotWrapper = $('<div class="dot-wrapper"></div>');
      for (var i = 0; i < s; i++) {
        var $dot = $('<span class="dot"></span>');
        if (i === 0) {
          $dot.addClass('current');
        }
        this.$dotWrapper.append($dot);
      }

      if (1 < s) {
        this.$next.removeClass('hide');

        this.$self.append(this.$prev);
        this.$self.append(this.$next);
        this.$self.append(this.$dotWrapper);
      }

      this.index = 0;
      var _self = this;

      this.$prev.on('click', function () {
        _self.index--;
        if (_self.index < 0) {
          _self.index = 0;
        }
        _self.slide(w * _self.index, s);
        return false;
      });

      this.$next.on('click', function () {
        _self.index++;
        if (s <= _self.index) {
          _self.index = s - 1;
        }
        _self.slide(w * _self.index, s);
        return false;
      });
    };

    FigureCarousel.prototype.slide = function (x, s) {

      if (this.$item.eq(this.index).find('img').length === 0) {
        var src = this.data[this.index].figure;
        var $img = $('<img src="' + src + '" />"');
        this.$item.eq(this.index).find('.fig').append($img);
      }

      this.$inner.css({
        '-webkit-transform': 'translate(-' + x + 'px, 0)',
        'transform': 'translate(-' + x + 'px, 0)'
      });

      if (this.index === 0) {
        this.$prev.addClass('hide');
      } else {
        this.$prev.removeClass('hide');
      }

      if (this.index === s - 1) {
        this.$next.addClass('hide');
      } else {
        this.$next.removeClass('hide');
      }

      this.$dotWrapper.find('.dot').removeClass('current');
      this.$dotWrapper.find('.dot:nth-of-type(' + (this.index + 1) + ')').addClass('current');
    }

    return FigureCarousel;
  })();

  var mfa = new MoniterFixedAdd();

  return {

    // スクロール監視スクリプトを開始
    startMonitorScrooling: function () {
      (new MonitorScrooling()).start();
    },

    // スクロール監視スクリプトを開始
    startMoniterFixedAdd: function () {
      mfa.setConditions();
      mfa.startMoniter();
    },

    // スクロール監視スクリプトの条件を再設定
    restartMoniterFixedAdd: function () {
      mfa.setConditions();
      setTimeout(function () {
        mfa.monitering();
      }, 10);
    },

    // 写真カルーセルのセット
    setFigureCarousel: function (id, data) {
      new FigureCarousel({
        id: id,
        data: data
      });
    },

    // 指定された配列からランダムで指定数だけ抜き出す
    random: function (array, num) {
      var a = array;
      var t = [];
      var r = [];
      //      var l = a.length;
      var l = Object.keys(a).length;
      var n = num < l ? num : l;
      while (n-- > 0) {
        var i = Math.random() * l | 0;
        r[n] = t[i] || a[i];
        --l;
        t[i] = t[l] || a[l];
      }
      return r;
    },

    // 指定された文字列を特定の長さでカットし、カットした場合は最後に ... を付加する
    cutString: function (text, size) {
      var str = text;
      var afterTxt = '…';

      var textLength = text.length;
      var textTrim = text.substr(0, (size - 1));

      if (size < textLength) {
        str = textTrim + afterTxt;
      }
      return str;
    },

    // 続きを見るをクリックした時の処理
    openNewsDetail: function () {
      $('.detailContent-inner').removeClass(function (index, className) {
        return (className.match(/\bcut\S+/g) || []).join(' ');
      });
      this.restartMoniterFixedAdd();
    },

    openNewsDetailLargePhoto: function () {
      $('.detailContent-inner').removeClass(function (index, className) {
        return (className.match(/\bcut\S+/g) || []).join(' ');
      });
      (function (w, t, d, s) {
        d = w.document; w.ggv2id = t; s = d.createElement('script');
        s.async = true; s.src = 'https://js.gumgum.com/services.js';
        d.getElementsByTagName('head')[0].appendChild(s);
      }
        (top, 'cbduefmc'));
      this.restartMoniterFixedAdd();
    },
    // Facebookのシェアを実行
    shareFacebook: function (targetUrl) {
      var url = targetUrl;
      if (!url) {
        url = document.URL;
      }
      if (url.slice(-1) == '#') {
        //末尾が # の時に # を削除
        url = url.slice(0, -1);
      }
      url = encodeURIComponent(url);

      var href = 'http://www.facebook.com/sharer/sharer.php?u=' + url;

      window.open().location.href = href;
    },

    // Twitterのシェアを実行
    shareTwitter: function (targetUrl) {
      var url = targetUrl;
      if (!url) {
        url = document.URL;
      }
      if (url.slice(-1) == '#') {
        //末尾が # の時に # を削除
        url = url.slice(0, -1);
      }
      url = encodeURIComponent(url);

      //テキスト
      var text = document.title;
      text = encodeURIComponent(text);

      //経由
      var via = 'Daily_Online';
      via = encodeURIComponent(via);

      //関連アカウント
      var related = '';
      related = encodeURIComponent(related);

      //ハッシュタグ
      var hashtags = '';
      if (url.indexOf('matome') != -1) {
        hashtags = 'デイリーまとめ';
      }
      hashtags = encodeURIComponent(hashtags);

      var href = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + text + '&via=' + via + '&related=' + related + '&hashtags=' + hashtags;
      window.open().location.href = href;
      //return false;

    },

    // はてなのシェアを実行
    shareHatena: function (targetUrl) {
      var url = targetUrl;
      if (!url) {
        url = document.URL;
      }
      if (url.slice(-1) == '#') {
        //末尾が # の時に # を削除
        url = url.slice(0, -1);
      }
      url = encodeURIComponent(url);

      //タイトル
      var title = document.title;
      title = encodeURIComponent(title);

      var href = 'http://b.hatena.ne.jp/entry/panel/?url=' + url + '&title=' + title;
      window.open().location.href = href;

      //return false;
    },

    // 個別リンクを取得
    getIndividualJson: function (arg) {
      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id,
        pos = arg.pos;

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合

        var createHTML = function (data) {
          var html = '';
          if (data !== undefined) {
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              var figure = item.figure;
              if (item.figure === undefined) {
                figure = '';
              }
              var classThumb = '';
              if (figure !== '') {
                classThumb = ' class="addThumb"';
              }
              html += '<li' + classThumb + '>';
              html += '<a href="' + item.url + '">';
              html += '<article><h1>' + DAILY.cutString(item.title, 30) + '</h1>';
              if (figure !== '') {
                html += '<figure class="thumb"><img src="' + item.figure + '" /></figure>';
              }
              html += '</article></a></li>';
            }
          }
          return html;
        };

        var createTABLE = function (data) {
          var html = '';
          if (data !== undefined) {
            var a = data[0].url;
            var a = a.replace("/table/link_sys/tb", "/table/tb");
            var a = a.replace("html", "shtml");
            html = '<a href="' + a + '"><h2 class="ttl-section">' + data[0].title + '</h2>';
            $.ajax({
              type: 'GET',
              url: data[0].url,
              dataType: 'html',
              async: false,
              cache: false,
            }).done(function (data) { //ajaxの通信に成功した場合
              html += data;
              html += '</a>';
            }).fail(function (e) {
              console.log(tableFAIL);
            });
            return html;
          }
        };

        var excerpt = {
          primary: function () {
            return createHTML(data.primary).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          secondary: function () {
            return createHTML(data.secondary).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          tertiary: function () {
            return createHTML(data.tertiary).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          table: function () {
            return createTABLE(data.table);
          }
        };

        var html = excerpt[pos]();
        if (html === '') {
          if (pos === 'primary') {
            $(arg.id).parent().parent().hide();
          } else {
            $(arg.id).parent().hide();
          }
        } else {
          $(arg.id).html(excerpt[pos]());
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        if (pos === 'primary') {
          $(arg.id).parent().parent().hide();
        } else {
          $(arg.id).parent().hide();
        }
      });
    },

    // ジャンルリンクを取得
    getGenreJson: function (arg) {

      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id;

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (oriData) { //ajaxの通信に成功した場合

        // 配列からランダムで5つ取り出す
        var data = DAILY.random(oriData, 5);

        var html = '';
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          var figure = item.figure;
          if (item.figure === undefined) {
            figure = '';
          }
          var classThumb = '';
          if (figure !== '') {
            classThumb = ' class="addThumb"';
          }
          html += '<li' + classThumb + '>';
          html += '<a href="' + item.url + '">';
          html += '<article><h1>' + DAILY.cutString(item.title, 30) + '</h1>';
          if (figure !== '') {
            html += '<figure class="thumb"><img src="' + item.figure + '" /></figure>';
          }
          html += '</article></a></li>';
        }

        if (html === '') {
          $(arg.id).parent().hide();
        } else {
          $(arg.id).html(html);
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        $(arg.id).parent().hide();
      });
    },

    // ジャンルリンクを取得(ad_ng)
    getGenreJsonAdNG: function (arg) {
      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id,
        pos = arg.pos;

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var createHTML = function (data) {
          // 配列からランダムで5つ取り出す
          var randdata = DAILY.random(data, 5);
          var html = '';
          if (randdata !== undefined) {
            for (var i = 0; i < randdata.length; i++) {
              var item = randdata[i];
              var figure = item.figure;
              if (item.figure === undefined) {
                figure = '';
              }
              var classThumb = '';
              if (figure !== '') {
                classThumb = ' class="addThumb"';
              }
              html += '<li' + classThumb + '>';
              html += '<a href="' + item.url + '?pg=r111' + '">';
              html += '<article><h1>' + DAILY.cutString(item.title, 30) + '</h1>';
              if (figure !== '') {
                html += '<figure class="thumb"><img src="' + item.figure + '" /></figure>';
              }
              html += '</article></a></li>';
            }
          }
          return html;
        };

        var createTABLE = function (data) {
          // 配列からランダムで5つ取り出す
          var randdata = DAILY.random(data, 5);
          var html = '';
          if (randdata !== undefined) {
            var a = randdata[0].url;
            var a = a.replace("/table/link_sys/tb", "/table/tb");
            var a = a.replace("html", "shtml");
            html = '<a href="' + a + '"><h2 class="ttl-section">' + randdata[0].title + '</h2>';
            $.ajax({
              type: 'GET',
              url: randdata[0].url,
              dataType: 'html',
              async: false,
              cache: false,
            }).done(function (randdata) { //ajaxの通信に成功した場合
              html += randdata;
              html += '</a>';
            }).fail(function (e) {
              console.log(tableFAIL);
            });
            return html;
          }
        };

        var excerpt = {
          primary: function () {
            return createHTML(data).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          secondary: function () {
            return createHTML(data).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          tertiary: function () {
            return createHTML(data).replace(/daily\.c\.yimg/g, 'i.daily');
          },
          table: function () {
            return createTABLE(data);
          }
        };

        var html = excerpt[pos]();
        if (html === '') {
          if (pos === 'primary') {
            $(arg.id).parent().parent().hide();
          } else {
            $(arg.id).parent().hide();
          }
        } else {
          $(arg.id).html(excerpt[pos]());
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        if (pos === 'primary') {
          $(arg.id).parent().parent().hide();
        } else {
          $(arg.id).parent().hide();
        }
      });
    },

    // アーカイブを取得
    getArchiveJson: function (arg) {

      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id;

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合

        var html = '';
        for (var i = 0; i < data.length; i++) {
          var headline = data[i].headline[0],
            news = data[i].news;

          var date = headline.update.split('-'),
            url = headline.url;

          if (url === undefined) {
            url = '';
          }

          html += '<section><div class="ttl-section"><h1>' + headline.title + '</h1>';
          html += '&nbsp;<time datetime="' + headline.update + '" class="date">Up Date : ';
          html += date[0] + '.' + date[1] + '.' + date[2];
          html += '</time>';
          if (url !== '') {
            html += '<a href="' + url + '" class="btn-link">過去記事一覧へ</a>';
          }
          html += '</div><div class="thumbnailNews-wrapper"><ul class="linkLists txt-ellipsis">';

          var figure = '';
          for (var j = 0; j < news.length; j++) {
            var item = news[j];
            html += '<li>';
            html += '<a href="' + item.url + '">';
            html += '<article><h1>' + item.title + '</h1>';
            html += '</article></a></li>';

            if (figure === '') {
              var getFigure = item.figure;
              if (getFigure === undefined) {
                getFigure = '';
              }

              if (getFigure !== '') {
                figure = getFigure;
              }
            }
          }
          html += '</ul>';
          if (figure !== '') {
            html += '<div class="thumb thumbnail">';
            html += '<img src="' + figure + '" />';
            html += '</div>';
          }
          html += '</div></section>';
        }

        $(arg.id).html(html);
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    // ランキングを取得
    getRankingJson: function (arg) {
      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id;

      if (url === undefined || id === undefined) {
        return;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          var figure = item.figure;
          if (item.figure === undefined) {
            figure = '';
          }
          var classThumb = '';
          if (figure !== '') {
            classThumb = ' class="addThumb"';
          }
          html += '<li' + classThumb + '>';
          html += '<a href="' + item.url + '">';
          html += '<article><h1>' + item.title + '</h1>';
          if (figure !== '') {
            html += '<figure class="thumb"><img src="' + item.figure + '" /></figure>';
          }
          html += '</article></a></li>';
        }
        if (html === '') {
          $(arg.id).parent().parent().hide();
        } else {
          $(arg.id).html(html);
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        $(arg.id).parent().parent().hide();
      });
    },

    // まとめランキングを取得
    getMatomeRankingJson: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        reurn;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        var value = data;

        // オリジナル関数を使ってオブジェクトの中身を取得
        for (var i = 0; i < value.length; i++) {
          var title = value[i].title,
            href = value[i].url,
            src = value[i].figure

          if (src === undefined) {
            src = '';
          }

          html += '<li>';
          html += '<a href="' + href + '">';
          html += '<figure class="thumb">';
          html += '<img src="' + src + '" alt="' + title + '" />';
          html += '</figure>';
          html += '<div class="caption">';
          html += '<span class="title">' + title + '</span>';
          html += '</div>';
          html += '</a>';
          html += '</li>';
        };
        $(arg.id).html(html)

      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    // まとめ記事一覧を取得
    getMatomeListJson: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        return;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        var value = data.lists;
        var length = value.length;
        var start = 0;

        //もっと見るボタンで呼び出しだった場合
        if ((arg.jsonLength !== undefined) && (arg.jsonLength <= length)) {
          //上限件数を設定
          length = (arg.jsonLength + arg.count) > length ? length : (arg.jsonLength + arg.count);
          //スタート値を設定
          start = arg.jsonLength;
        }

        for (var i = start; i < length; i++) {
          var title = value[i].title,
            honbun = value[i].honbun,
            href = value[i].fileId,
            src = value[i].photoId,
            alt = value[i].photoTxt,
            category = value[i].category,
            categoryName = value[i].categoryName,
            dateRelease = value[i].dateRelease,
            photoDate = value[i].photoDate,
            date = value[i].dateDelivery,
            tagList = value[i].tags;

          var formatDate = DAILY.formatDate(new Date(date), 'YYYY.MM.DD');

          if (src === undefined) {
            src = '';
          }

          html += '<li class="jsn">';
          html += '<a href="/' + category + '/matome/' + dateRelease + '/' + href + '.shtml">';
          html += '<article class="listItem">';
          html += '<div class="outline">';
          html += '<ul class="tagList">';
          html += '<li><span class="tagLink categoryTag ' + category + '" data-taglink="' + category + '">' + categoryName + '</span></li>';
          for (var j = 0; j < tagList.length; j++) {
            html += '<li>';
            html += '<span class="tagLink" data-taglink="' + tagList[j].id + '">' + tagList[j].name;
            //if(tagList[j].count && tagList[j].count > 0){
            //  html += '<span class="count roboto">(' + tagList[j].count + ')</span>';
            //}
            html += '</span></li>';
          }
          html += '</ul>';
          html += '<h3 class="ttl">' + title + '</h3>';
          html += '<div class="txt">';
          html += DAILY.substr(honbun, 72, '…');
          // ↓↓ JSで三点リーダー化しない場合
          // html += honbun;
          // ↑↑ JSで三点リーダー化しない場合
          html += '</div>';
          html += '<time class="date roboto">' + formatDate + '</time>';
          html += '</div>';
          html += '<div class="thumb-wrapper">';
          html += '<figure class="thumb">';
          html += '<img src="//i.daily.jp/' + category + '/matome/' + photoDate + '/Images/e_' + src + '" alt="' + alt + '">';
          html += '</figure>';
          html += '</div>';
          html += '</article>';
          html += '</a>';
          html += '</li>';
        }
        $(arg.id).append(html);

        if (arg.count && (length == value.length)) {
          //もっと見るボタンを押した場合で、最大数までjsonを表示した場合
          $("#moreShowBtn").css('display', 'none');
        }

        // 初期表示件数の指定
        if ($('.listContent .newsLists .lists').hasClass('first')) {
          var firstViewNum = 4;
          var newsCount = $('.listContent .newsLists .lists > li').length;
          $('.listContent .newsLists .lists > li:nth-child(n+' + (firstViewNum + 1) + ')').hide();
        }

      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    // まとめ記事一覧 もっと見るボタン押下
    getMoreNews: function (arg) {
      if ($('.listContent .newsLists .lists').hasClass('first')) {
        // 初回時は非表示の記事を表示
        $('.listContent .newsLists .lists > li').show();
        $('.listContent .newsLists .lists').removeClass('first');
      } else {
        // 2回目以降は取得したJsonを元に生成
        //htmlベタ書きの件数を取得
        arg.htmlLength = $("#matomeList > li:not('.jsn')").length;
        arg.currentLength = $("#matomeList > li").length;
        arg.jsonLength = arg.currentLength - arg.htmlLength + 1;
        DAILY.getMatomeListJson(arg);
      }
    },

    // タグ一覧（おすすめ）を取得
    getRecommendListJson: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        return;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        var value = data.tags;

        for (var i = 0; i < value.length; i++) {
          var name = value[i].name,
            count = value[i].count,
            href = value[i].id;

          html += '<li>';
          html += '<a href="' + href + '">';
          html += '<span>' + name + '</span>';
          html += '<span class="count">(' + count + ')</span>';
          html += '</a>';
          html += '</li>';
        }
        $(arg.id).append(html);

      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    //PCヘッダー用まとめタグ取得
    getMatomePcHeaderTagJson: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        return;
      }

      $('.btnlists span').one('click', function () {
        $.ajax({
          type: 'GET',
          url: arg.url,
          dataType: 'json'
        }).done(function (data) { //ajaxの通信に成功した場合
          var html = '';
          var value = data.genre;

          for (var i = 0; i < value.length; i++) {
            var category = value[i].category,
              categoryName = value[i].categoryName,
              tagCount = value[i].count;

            if (tagCount > 0) { //カテゴリに紐付くタグがある場合

              html += '<li>';
              html += '<div class="areaLink">';
              html += '<a href="/' + category + '/matome/">' + categoryName + '</a>';
              html += '</div>';
              html += '<ul class="subGenreLists linkLists">';

              var tags = value[i].tags;
              for (var j = 0; j < tags.length; j++) {
                var tagCategory = tags[j].category,
                  tagCategoryName = tags[j].name,
                  id = tags[j].id;

                html += '<li>';
                html += '<a href="/' + tagCategory + '/matome/' + id + '/">' + tagCategoryName + '</a>';
                html += '</li>';
                if (j === 7) {
                  break;
                }
              }
              html += '</ul>';
            }
          }
          $(arg.id).append(html);

        }).fail(function (e) { //ajaxの通信に失敗した場合
          console.log('FAIL', e);
        });
      });
    },

    //PCヘッダー用まとめタグ取得
    getMatomePcHeaderTagJsonCategory: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        return;
      }
      $('.btnlists span').one('click', function () {
        $.ajax({
          type: 'GET',
          url: arg.url,
          dataType: 'json'
        }).done(function (data) { //ajaxの通信に成功した場合
          var html = '';
          var value = data.genre;

          for (var i = 0; i < value.length; i++) {
            var category = value[i].category;
            if (arg.category == category && value[i].tags.length > 0) {

              html += '<li>';
              html += '<div class="areaLink" id="addMatomeTag">';
              html += '<a href="/' + category + '/matome/">まとめ</a>';
              html += '</div>';
              html += '<ul class="subGenreLists linkLists">';

              var tags = value[i].tags;
              for (var j = 0; j < tags.length; j++) {
                var tagCategory = tags[j].category,
                  tagCategoryName = tags[j].name,
                  id = tags[j].id;

                html += '<li>';
                html += '<a href="/' + tagCategory + '/matome/' + id + '/">' + tagCategoryName + '</a>';
                html += '</li>';
                if (j === 7) {
                  break;
                }
              }
              html += '</ul>';
            }
          }
          $(arg.id).append(html);

        }).fail(function (e) { //ajaxの通信に失敗した場合
          console.log('FAIL', e);
        });
      });
    },

    // タグ一覧画面表示用
    getTagListJson: function (arg) {
      if (arg.url === undefined || arg.id === undefined) {
        return;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        var value = data.tags;
        var value = data.genre;

        for (var i = 0; i < value.length; i++) {
          var category = value[i].category,
            categoryName = value[i].categoryName,
            tagCount = value[i].count;

          if (tagCount > 0) {//ここから
            var tags = value[i].tags;

            html += '<h2 class="ttl-section">' + categoryName + '</h2>';
            html += '<ul class="matome keywordLists">';


            for (var j = 0; j < tags.length; j++) {
              var tagCategory = tags[j].category,
                tagCategoryName = tags[j].name,
                id = tags[j].id,
                count = tags[j].count;

              html += '<li>';
              html += '<a href="/' + tagCategory + '/matome/' + id + '/index.shtml">';
              html += '<span>' + tagCategoryName + '</span>';
              html += '<span class="count">(' + count + ')</span>';
              html += '</a>';
              html += '</li>';
            }
            html += '</ul>';

          }//ここまで
        }
        $(arg.id).append(html);

      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    // 写真情報を取得
    getPhotoJson: function (arg) {
      if (typeof arg !== 'object') {
        return;
      }

      var url = arg.url,
        id = arg.id;

      if (url === undefined || id === undefined) {
        return;
      }

      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'json'
      }).done(function (data) { //ajaxの通信に成功した場合

        var html = '';
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          var figure = item.figure;
          if (item.figure === undefined) {
            figure = '';
          }
          if (figure !== '') {
            html += '<a href="' + item.url + '" class="figureCarousel-item">';
            html += '<figure class="fig">';
            if (i === 0) {
              html += '<img src="' + figure + '">';
            }
            html += '</figure>';
            html += '<div class="caption">' + item.title;
            html += '</div></a>';
          }
        }

        if (html !== '') {
          var oriHtml = $(arg.id).find('.figureCarousel-inner').html();
          $(arg.id).find('.figureCarousel-inner').html(oriHtml + html);

          DAILY.setFigureCarousel(arg.id, data)
        }

      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
      });
    },

    // 関連ニュースを取得
    getRelationJson: function (arg) {
      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'jsonp',
        cache: true,
        jsonpCallback: 'relation'
      }).done(function (data) { //ajaxの通信に成功した場合

        var html = '';
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          html += '<li>';
          html += '<a href="' + item.url + '">';
          html += '<article><h1>' + item.title + '</h1>';
          html += '</article></a></li>';
        }

        if (html === '') {
          $(arg.id).parent().hide();
        } else {
          $(arg.id).html(html);
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        $(arg.id).parent().hide();
      });
    },

    // 関連ニュースを取得（写真付き）
    getRelationJsonWithPhoto: function (arg, callback) {
      $.ajax({
        type: 'GET',
        url: arg.url,
        dataType: 'jsonp',
        cache: true,
        jsonpCallback: 'relation'
      }).done(function (data) { //ajaxの通信に成功した場合
        var html = '';
        if (!data) {
          $(arg.id).parent().hide();
          callback('relation data is nothing');
        } else {
          var mainFlg = false;
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            var li = '';
            //取得した最初の画像をメイン画像に設定
            if (item.photo) {
              if (!mainFlg) {
                li += '<li class="mainThumb">';
              } else {
                li += '<li class="addThumb">';
              }
            } else {
              li += '<li>';
            }
            li += '<a href="' + item.url + '">';
            li += '<article><span class="ttlWrapper"><h1 class="ttl">';
            li += '' + item.title + '';
            li += '</h1></span>';
            if (item.photo) {
              li += '<figure class="thumb"><img src="' + item.photo + '" alt="' + item.title + '"></img></figure>';
            }
            li += '</article></a></li>';

            if (item.photo && !mainFlg) {
              //メイン画像をliの先頭に設定
              html = li + html;
              mainFlg = true;
            } else {
              html += li;
            }
          }
          if (html === '') {
            $(arg.id).parent().parent().hide();
            callback('relation html is nothing');
          } else {
            $(arg.id).html(html);
            callback(null);
          }
        }
      }).fail(function (e) { //ajaxの通信に失敗した場合
        console.log('FAIL', e);
        $(arg.id).parent().hide();
        callback('(getRelation) ajax failed');
      });
    },

    // カウントダウンを開始
    startCountdown: function (arg) {

      if (typeof arg !== 'object') {
        return;
      }

      var cs = arg.cs;
      if (cs === undefined) {
        reurn;
      }

      var $cs = $(cs);
      if ($cs.length === 0) {
        return;
      }

      var day = $cs.find('.day').text(),
        hour = $cs.find('.hour').text(),
        minute = $cs.find('.minute').text(),
        second = $cs.find('.second').text();
      if (isNaN(day) || isNaN(hour) || isNaN(minute) || isNaN(second)) {
        return;
      }

      day = parseInt(day);
      hour = parseInt(hour);
      minute = parseInt(minute);
      second = parseInt(second);

      var timer = setInterval(function () {
        second--;

        if (second < 0) {
          minute--;
          second = 59;
        }

        if (minute < 0) {
          hour--;
          minute = 59;
        }

        if (hour < 0) {
          day--;
          hour = 23;
        }

        if (day < 0) {
          day = 0;
        }

        // 期日に達していたら、カウントダウンを停止
        if (day === 0 && hour === 0 && minute === 0 && second === 0) {
          clearInterval(timer);
        }

        $cs.find('.day').text(('0' + day).substr(-2, 2));
        $cs.find('.hour').text(('0' + hour).substr(-2, 2));
        $cs.find('.minute').text(('0' + minute).substr(-2, 2));
        $cs.find('.second').text(('0' + second).substr(-2, 2));
      }, 1000);
    },

    // 時計を開始
    startClock: function (arg) {

      if (typeof arg !== 'object') {
        return;
      }

      var cs = arg.cs;
      if (cs === undefined) {
        reurn;
      }

      var $cs = $(cs);
      if ($cs.length === 0) {
        return;
      }

      var getDay = $cs.find('.day').text();

      var year,
        month,
        day,
        hour = $cs.find('.hour').text(),
        minute = $cs.find('.minute').text(),
        second = $cs.find('.second').text();

      var divDay = getDay.split('.');

      if (divDay.length !== 3) {
        return;
      }

      if (isNaN(divDay[0]) || isNaN(divDay[1]) || isNaN(divDay[2]) || isNaN(hour) || isNaN(minute) || isNaN(second)) {
        return;
      }

      year = parseInt(divDay[0]);
      month = parseInt(divDay[1]);
      day = parseInt(divDay[2]);
      hour = parseInt(hour);
      minute = parseInt(minute);
      second = parseInt(second);

      var date = new Date(year, (month - 1), day, hour, minute, second);

      var timer = setInterval(function () {
        date.setSeconds(date.getSeconds() + 1);

        var setDay = date.getFullYear() + '.' + ('0' + (date.getMonth() + 1)).substr(-2, 2) + '.' + ('0' + date.getDate()).substr(-2, 2);

        $cs.find('.day').text(setDay);
        $cs.find('.hour').text(('0' + date.getHours()).substr(-2, 2));
        $cs.find('.minute').text(('0' + date.getMinutes()).substr(-2, 2));
        $cs.find('.second').text(('0' + date.getSeconds()).substr(-2, 2));

      }, 1000);
    },

    //画像遅延読み込み処理　サムネイルの表示制御あり
    delayImage: function () {
      var _self = this;
      _self.loadFlg = '';

      if (_self.loadFlg) {
        return;
      }

      $('.delayLoading').each(function () {
        if (!$(this).is('.hide')) {
          var $thumb = $(this);
          var $img = $thumb.find('img');
          var img_src = $img.attr('data-src');
          // 表示されていない画像
          if ($img.attr('src') != img_src) {
            // 画像位置よりウィンドウ最下部が超えた時
            if ($(window).scrollTop() + $(window).height() - 100 > $img.offset().top) {
              _self.loadFlg = 'true';
              //画像表示
              $img.attr('src', img_src);
              $thumb.removeClass('delayLoading');

              // 読み込んだサムネイルの表示制御
              var $img = $img;

              // サーバーからの画像の幅・高さ指定がない場合は、向き指定の処理は終了
              var dW = $img.attr('data-width'),
                dH = $img.attr('data-height');

              if (dW === undefined || dH === undefined) {
                return;
              }

              var tW = $thumb.width(),
                tH = $thumb.height();

              var ratioT = tW / tH,
                ratioD = dW / dH;

              if (ratioD < 1) {
                $thumb.addClass('portrait');
              } else {
                if (ratioT < ratioD) {
                  $thumb.addClass('landscape');
                }
              }
            } else {
              return;
            }
          } else {
            return;
          }
        }
      });
      return false;
    },

    // 文字列を指定バイト数切り取り、指定文字列に置き換える
    substr: function (text, len, truncation) {
      if (truncation === undefined) {
        truncation = '';
      }
      var text_array = text.split('');
      var count = 0;
      var str = '';
      for (var i = 0; i < text_array.length; i++) {
        var n = escape(text_array[i]);
        if (n.length < 4) {
          count++;
        } else {
          count += 2;
        }
        if (count > len) {
          return str + truncation;
        }
        str += text.charAt(i);
      }
      return text;
    },

    // 指定日を指定フォーマット文字列に変換
    formatDate: function (date, format) {
      if (!format) format = 'YYYY-MM-DD hh:mm:ss';
      format = format.replace(/YYYY/g, date.getFullYear());
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
      if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        var length = format.match(/S/g).length;
        for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
      }
      return format;
    },
    /*API関連で神戸で追加*/
    getArticleListFromApi: function (fileName, startNum, endNum, funcName) {
      var url = '/api/articlelist.php';
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
          'fileName': fileName,
          'startArticleNum': startNum,
          'endArticleNum': endNum,
        },
      }).done(function (response) {
        //成功時の処理
        if (response['result'] === false) {
          //異常時の処理
          console.log(response['messeage']);
        } else {
          //正常時の処理
          var data = response['article'];
          funcName(data);
          return data;
        }
      }).fail(function (result) {
        console.log("error_ajax");
      });
    },
    displayTopInfoUl: function (data) {
      var html = '';
      for (var i = 0; i < 2; i++) {
        html += '<li><a href="' + data[i].url + '">' + data[i].headline + '</a></li>';
      }
      $('#travelInfoUl').append(html);
    },
    createTopTravelList: function (arg) {
      if (typeof arg != 'object') {
        return false;
      }
      var fileName = arg.fileName;
      var startNum = arg.startNum;
      var endNum = arg.endNum;
      DAILY.getArticleListFromApi(fileName, startNum, endNum, DAILY.displayTopInfoUl);
    }
  };
}());


/*
 * ページのドキュメント読み込みが完了した時の処理
 */
$(function () {

  //画像の遅延読み込み（初回時）
  DAILY.delayImage();

  // ヘッダー部のfixed化処理
  var headerT;
  var headerH;
  var genreT;
  var prevScroll = 0;

  // スクロールの状況によって発生するイベント
  $(window).on({

    // 上方向にスクロールした時
    scrollup: function (e, arg) {
      if (arg.scroll < headerT + genreT) {
        $('.wrapper').removeClass('is-fixedHeader is-fixedAnimation');
      } else if (arg.scroll < headerH) {
        $('.wrapper').removeClass('is-fixedAnimation');
      }
    },

    // 下方向にスクロールした時
    scrolldown: function (e, arg) {
      if (headerT + headerH < arg.scroll) {
        $('.wrapper').addClass('is-fixedHeader is-fixedAnimation');
      }
    },

    load: function () {
      headerT = $('.pageHeader').offset().top;
      headerH = $('.pageHeader').height();
      genreT = $('.pageInfo').height() + $('.mainNavigation').height();
    },

    scroll: function () {
      $('.pageHeader').removeClass('is-openGenre is-openSearch');

      var nowScroll = $(window).scrollTop();

      if (nowScroll > prevScroll) {
        // 今のスクロール量がこれの一つ前の計測時より大きい場合
        $(window).trigger('scrolldown', { scroll: nowScroll });
      } else if (prevScroll > nowScroll) {
        // 今のスクロール量がこれの一つ前の計測時より小さい場合
        $(window).trigger('scrollup', { scroll: nowScroll });
      }

      prevScroll = nowScroll;

      // 画像の遅延読み込み
      DAILY.delayImage();
    }
  });

  // ヘッダー部検索表示ボタンのクリック制御
  $('.pageSearchBtn').on('click', function () {
    $('.pageHeader').removeClass('is-openGenre');
    $('.pageHeader').toggleClass('is-openSearch')
  });

  // ヘッダー部「一覧」のクリック制御
  $('.mainNavigation .navigation li .btnlists, .genreNavigation-inner .btnlists').on('click', function () {
    $('.pageHeader').removeClass('is-openSearch');
    $('.pageHeader').toggleClass('is-openGenre');

    //ヘッダー部「一覧」内にまとめタグ要素追加(初回表示時のみ実行)
    if ($("#addMatomeTag").length == 0) {
      var href = window.location.href;
      var domain = href.indexOf("/", 8) + 1;
      var category = href.substring(domain, href.indexOf("/", domain + 1));
      var arg = { url: '/matome/tagList.json', id: '#addMatome', category: category };
      DAILY.getMatomePcHeaderTagJsonCategory(arg);
    }
  });

  // 写真一覧（グリッドタイプ）のタイトル部・リンク部の高さを補正
  $('.photoGrid.grid-2, .photoGrid.grid-3').each(function () {
    var $header = $(this).find('.grid-column .header');
    var $keyword = $(this).find('.grid-column .keywordLists');

    var maxHeaderH = 0;
    var maxKeywordH = 0;

    $header.each(function () {
      var h = $(this).height();
      if (maxHeaderH < h) {
        maxHeaderH = h;
      }
    });
    $header.height(maxHeaderH);

    $keyword.each(function () {
      var h = $(this).height();
      if (maxKeywordH < h) {
        maxKeywordH = h;
      }
    });
    $keyword.height(maxKeywordH);
  });

  // タブ部分のクリック制御
  $('.js-tab').each(function () {
    var $tab = $(this).find('.tab');
    var index = 0;
    $tab.each(function () {
      $(this).find('.ttl').data('index', index);
      index++;
    });

    $tab.find('.ttl').on('click', function () {
      var index = $(this).data('index');
      if (index === undefined) {
        return;
      }
      $tab.removeClass('current');
      $tab.eq(index).addClass('current');
    });
  });

  // 神戸追記版フツター部カテゴリーをクリック
  var $footerNav = $('.pageFooter .navigation-item');
  $footerNav.find('> a').on('click', function () {

    $footerNav.removeClass('current');
    var $thisNav = $(this).parent();
    var getFileGenreName = $thisNav.attr('class');

    //まとめの場合は別フォーマットのjsonより取得するため別処理を行う
    //if(getFileGenreName.indexOf("matome") != -1){
    //  setFooterMatome($thisNav,getFileGenreName);
    //  return false;
    //}

    var footerFilePath = '/' + getFileGenreName.replace('navigation-item ', '') + '/lib16/footerMenuSubGenre.json';
    var subNaviText = $thisNav.children('.subNavigation').text().trim();

    var $footerNavInner = $('.pageFooter .navigation-inner');
    $footerNavInner.height('auto');

    if (subNaviText === "") {
      getFileName = footerFilePath;
      $.getJSON(getFileName, function (data) {
        var subNavigation = '';
        for (i = 0; i < data.length - 1; i++) {
          subNavigation += '<li><a href="' + data[i].url + '">' + data[i].name + '</a></li>';
        }
        $('.' + getFileGenreName.replace('navigation-item ', 'navigation-item.')).children(".subNavigation").append(subNavigation);
        $thisNav.addClass('current');

        var h = $('.' + getFileGenreName.replace('navigation-item ', 'navigation-item.')).children(".subNavigation").height();
        $footerNavInner.height(100 + h);
      })
        .error(function (event, jqxhr, exception) {
          var link = $thisNav.children("a").attr("href")
          window.location.href = link;
        });
    } else {
      $thisNav.addClass('current');

      var h = $thisNav.children(".subNavigation").height();
      $footerNavInner.height(100 + h);

    }

    return false;
  });

  // まとめフッター別処理
  function setFooterMatome($thisNav, fileGenreName) {
    var footerFilePath = '../matome/lib16/footerMenuSubGenre.json';
    var subNaviText = $thisNav.children('.subNavigation').text().trim();

    var $footerNavInner = $('.pageFooter .navigation-inner');
    $footerNavInner.height('auto');

    if (subNaviText === "") {
      $.getJSON(footerFilePath, function (data) {
        var value = data.genre;
        var subNavigation = '';
        for (i = 0; i < value.length; i++) {
          var tags = value[i].tags;
          for (var j = 0; j < tags.length; j++) {
            var tagCategory = tags[j].category,
              tagCategoryName = tags[j].name,
              id = tags[j].id;

            subNavigation += '<li>';
            subNavigation += '<a href="/html/www/matome/' + id + '/index.shtml">' + tagCategoryName + '</a>';
            subNavigation += '</li>';
          }
        }
        $('.' + fileGenreName.replace('navigation-item ', 'navigation-item.')).children(".subNavigation").append(subNavigation);
        $thisNav.addClass('current');

        var h = $('.' + fileGenreName.replace('navigation-item ', 'navigation-item.')).children(".subNavigation").height();
        $footerNavInner.height(100 + h);
      });
    } else {
      $thisNav.addClass('current');

      var h = $thisNav.children(".subNavigation").height();
      $footerNavInner.height(100 + h);
    }
  }

  // ページトップにスクロール
  $('.linkPageTop').on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500, 'swing');
    return false;
  });

  // 文字サイズの調整
  var $fontWrapper = $('.newsHeader .font-wrapper');
  var $fontIcon = $('.newsHeader .font-wrapper a');
  if (0 < $fontWrapper.length) {

    var defSize = $.cookie("textsizemode");
    if (defSize === undefined) {
      defSize = 'middle';
    }

    $('.detailContent').addClass(defSize);
    $fontIcon.removeClass('current').each(function () {
      var size = $(this).data('size');
      if (size === defSize) {
        $(this).addClass('current');
        return;
      }
    });

    $fontIcon.on('click', function () {
      $fontIcon.removeClass('current');
      $(this).addClass('current');

      var size = $(this).data('size');

      $('.detailContent').removeClass('small middle large').addClass(size);
      $.cookie('textsizemode', size, { expires: 30, path: '/', domain: 'daily.co.jp' });

      return false;
    });
  }

  /*
    // 記事詳細部分の表示制御「続きを見る」クリックした時の処理
    $('.detailContent .newsContent .btnShow').on('click', function() {
      $('.detailContent-inner').removeClass(function(index, className) {
        return (className.match(/\bcut\S+/g) || []).join(' ');
      });
      return false;
    });
  */

  // サムネイル部分の表示制御
  $('.thumb').each(function () {
    var $thumb = $(this);
    var $img = $thumb.find('img');

    if ($img.length === 0) {
      return;
    }

    // サーバーからの画像の幅・高さ指定がない場合は、向き指定の処理は終了
    var dW = $img.attr('data-width'),
      dH = $img.attr('data-height');

    if (dW === undefined || dH === undefined) {
      return;
    }

    var tW = $thumb.width(),
      tH = $thumb.height();

    var ratioT = tW / tH,
      ratioD = dW / dH;

    if (ratioD < 1) {
      $thumb.addClass('portrait');
    } else {
      if (ratioT < ratioD) {
        $thumb.addClass('landscape');
      }
    }
  });
  //最新ニュース　ネイティブ広告　id内にテキストあれば４番目に表示
  //３本以下の時は末尾に追加
  if ($('#nativeNews').text()) {
    if ($("#mainGenreList li").length < 3) {
      $("#mainGenreList").append($('#nativeNews'));
    } else {
      $("#mainGenreList li:eq(2)").after($('#nativeNews'));
    }
    $('#nativeNews').show();
  }
});

// ページの各要素が完全に読み込まれた後の処理（画像部が絡む処理など）
$(window).on('load', function () {

  // サムネイル部分の表示制御
  $('.thumb').each(function () {
    var $thumb = $(this);
    var $img = $thumb.find('img');

    if ($img.length === 0) {
      return;
    }

    // サーバーからの画像の幅・高さ指定がある場合は、自動向き判定の処理は終了
    var dW = $img.data('width'),
      dH = $img.data('height');

    if (dW !== undefined && dH !== undefined) {
      return;
    }

    // 縦・横・デフォルトの表示がある場合は、自動判定の処理は終了
    if ($thumb.hasClass('portrait') || $thumb.hasClass('landscape') || $thumb.hasClass('default')) {
      return;
    }

    var tW = $thumb.width(),
      tH = $thumb.height(),
      iW = $img.width(),
      iH = $img.height();

    var ratioT = tW / tH,
      ratioI = iW / iH;

    if (ratioI < 1) {
      $thumb.addClass('portrait');
    } else {
      if (ratioT < ratioI) {
        $thumb.addClass('landscape');
      }
    }
  });

  DAILY.startMoniterFixedAdd();
  //スコア速報が1本しかない場合の処理
  if ($(".secondaryContents .liveScoreboard section").length === 1) {
    $(".secondaryContents .liveScoreboard section").addClass("current");
  }
  /* 検証 実際にはここは消す
    setTimeout(function() {
      console.log('ChangeAdd!!');

      $('.secondaryContents .add').removeClass('fixedAdd');

      DAILY.restartMoniterFixedAdd();
    }, 5000)
  */

});

/*画像上での右クリック禁止とマウスダウン禁止処理*/

document.addEventListener('DOMContentLoaded', function () {
  if (!location.href.match(/life/)) {
    $('img').on('mousedown', function () { return false; });
    $('img').on('contextmenu', function () { return false; });
  }
});
